<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['appName']),
    year() { return new Date().getFullYear() },
  },
}
</script>

<template>
  <div class="d-flex flex-column align-items-center justify-content-center bg-light">

    <div class="text-muted">
      &copy; {{appName}} {{year}}
    </div>

    <router-link :to="{name: 'feedback'}">
      Suggest Feature / Report Bug
    </router-link>

  </div>
</template>



// WEBPACK FOOTER //
// src/AppFooter.vue